import { render } from "./APTherapistAvailability.vue?vue&type=template&id=398faaf4"
import script from "./APTherapistAvailability.vue?vue&type=script&lang=js"
export * from "./APTherapistAvailability.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__